import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { ClaraConversationOrigin } from '@/modules/ai/constants/ClaraConversationOrigin';
import type { AuthUser } from '@/modules/auth/models/AuthUser';
import type { CurrentEstate } from '@/modules/estate/models/CurrentEstate';

export class BaseClaraForPlannersEventTracking extends BaseEventTracking {
  userId: number | undefined;
  userRole: string | undefined;
  payingCustomer: boolean | undefined;
  billingPlan: string | undefined;
  jurisdiction: string | undefined;
  estateId: number | undefined;
  sessionId: string;
  origin: ClaraConversationOrigin;

  constructor(authUser: AuthUser | null, sessionId: string) {
    super();
    const currentEstate: CurrentEstate | null | undefined = authUser?.currentEstate;

    this.userId = authUser?.id;
    this.userRole = authUser?.estateAccount?.roleName ?? authUser?.roleName;
    this.payingCustomer = authUser?.isPayingCustomer;
    this.billingPlan = currentEstate?.displayBillingPlan;
    this.jurisdiction = currentEstate?.jurisdiction?.name;
    this.estateId = currentEstate?.id;
    this.sessionId = sessionId;
    this.origin = ClaraConversationOrigin.PLANNER;
  }

  areAllPropertiesRequired(): boolean {
    return false;
  }
}
